export default {
  easyToStartPlayingData: [
    {
      title: "Analyze Fantasy Stocks In Top Cricketers",
      description:
        "Check out all player stocks in the marketplace. Use your knowledge and predictions to predict how players are going to perform.",
    },
    {
      title: "Build Your Portfolio",
      description:
        "Assemble a portfolio of players that you think will do well over a period of time. Choose how many fantasy stocks to buy in each player.",
    },
    {
      title: "Start Trading",
      description:
        "The better a player plays on the pitch, the higher their stock will rise! Be smart about your trades. Watch the games, watch the markets and sell your stocks when you are ready!",
    },
  ],
}
